export default "__VITE_ASSET__CxYoBtsi__"